module.exports = __webpack_public_path__ + "img/4.ea44ecb1.jpg";